import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Toolbar,
  AppBar,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import Atras from "./atras";
import { updateUser, auth, db } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

const Edit = () => {
  const [displayName, setDisplayName] = useState("");
  const [phone, setPhone] = useState("");
  const [point, setPoint] = useState("");
  const [status, setStatus] = useState({ type: "", message: "" });
  const [isSaving, setIsSaving] = useState(false);


  const handleDisplayNameChange = (event) => {
    setDisplayName(event.target.value);
  };

  const handlePhoneChange = (event) => {
    setPhone(event.target.value);
  };

  const handlePointChange = (event) => {
    setPoint(event.target.value);
  };

  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);

      if (!currentUser) {
        return;
      }

      try {
        const userRef = doc(db, "users", currentUser.uid);
        const userSnapshot = await getDoc(userRef);

        if (userSnapshot.exists()) {
          const userData = userSnapshot.data();
          setDisplayName(userData.displayName || "");
          setPhone(userData.phone || "");
          setPoint(userData.point || "");
        }
      } catch (error) {
        console.error("Error cargando datos del perfil:", error);
        setStatus({
          type: "error",
          message: "No se pudieron cargar los datos actuales.",
        });
      }
    });

    return () => unsubscribe();
  }, []);


  const handleSubmit = async () => {
    if (!user) {
      setStatus({ type: "error", message: "No hay usuario autenticado." });
      return;
    }

    setIsSaving(true);
    setStatus({ type: "", message: "" });

    try {
      await updateUser(user.uid, displayName, phone, point);
      setStatus({ type: "success", message: "Cambios guardados con éxito." });
    } catch (error) {
      console.error("Error actualizando perfil:", error);
      setStatus({
        type: "error",
        message: "No se pudo actualizar el perfil. Intenta nuevamente.",
      });
    } finally {
      setIsSaving(false);
    }
  };

  const styles = {
    cont: {
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      textAlign: "center",
      margin: 0,
      padding: 0,
      boxSizing: "border-box",
    },
    user: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "110px",
    },
  };

  return (
    <Container>
      <AppBar position="fixed" sx={{ bgcolor: "black" }}>
        <Toolbar
          sx={{
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <Atras color="inherit" />
          <Container style={styles.user}>
            <Typography variant="h5" gutterBottom>
              Editar perfil
            </Typography>
          </Container>
        </Toolbar>
      </AppBar>

      <Container
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          width: "100%",
          textAlign: "left",
          marginTop: "140px",
        }}
      >
        <TextField
          label="Nombre"
          variant="outlined"
          value={displayName}
          onChange={handleDisplayNameChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Teléfono"
          variant="outlined"
          value={phone}
          onChange={handlePhoneChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Localidad"
          variant="outlined"
          value={point}
          onChange={handlePointChange}
          fullWidth
          margin="normal"
        />
        {status.message && (
          <Alert severity={status.type === "success" ? "success" : "error"} sx={{ mt: 1 }}>
            {status.message}
          </Alert>
        )}
        <Button
          variant="contained"
          sx={{ mt: 1 }}
          color="primary"
          onClick={handleSubmit}
          disabled={isSaving}
        >
          Guardar cambios
        </Button>
      </Container>
    </Container>
  );
};

export default Edit;
